import { bMapSearch } from '@/modules/onlineMap/util';

export default {
    bMapSearch,
};
